export const customAttributesValuesCacheKey = "/app_settings/custom_attributes_values";
